import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const RipplePaperCupSleeves = () => (
  <ProductDetailPage {...getProductPageConfig('ripplePaperCupSleeves')} />
);

export default RipplePaperCupSleeves;
